var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVosslohLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 921.25983,
    height: 243.42519,
    id: "svg2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-619.33697,-26.962116)",
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.716498,17.749376)",
    id: "g18947"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 766.69176,88.144895 L 719.02216,88.144895 L 695.18736,183.61996 L 694.64406,183.61996 L 670.26606,88.144895 L 619.33697,88.144895 L 663.74716,227.41895 L 721.46676,227.41895 L 766.69176,88.144895",
    style: {
      fill: "#000000",
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path18705"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1025.9548,184.91017 C 1025.9548,160.59999 1015.3618,152.31553 997.77406,145.93245 L 981.47686,140.02466 C 969.86506,135.7466 965.24746,132.55506 965.24746,127.73379 C 965.24746,120.2642 973.12446,117.54795 982.56346,117.54795 C 995.05806,117.54795 1008.2992,122.09761 1017.2628,126.10407 L 1018.8928,91.404348 C 1008.5709,87.941206 994.24306,84.953356 979.64316,84.953356 C 936.79516,84.953356 920.83696,106.07195 920.83696,130.65373 C 920.83696,148.30912 927.35616,161.95811 949.83256,169.97097 L 964.70416,175.26758 C 976.65546,179.61356 980.45806,182.26184 980.45806,187.08316 C 980.45806,193.46624 973.66776,196.92943 960.35816,196.92943 C 943.31386,196.92943 931.09086,190.81796 923.55346,187.08316 L 922.46686,224.22741 C 930.27596,227.14735 950.10416,230.61054 965.51916,230.61054 C 1007.2131,230.61054 1025.9548,213.76996 1025.9548,184.91017",
    style: {
      fill: "#231f20",
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path18707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1139.7645,184.91017 C 1139.7645,160.59999 1129.171,152.31553 1111.5833,145.93245 L 1095.354,140.02466 C 1083.6744,135.7466 1079.0567,132.55506 1079.0567,127.73379 C 1079.0567,120.2642 1086.9337,117.54795 1096.4406,117.54795 C 1108.8673,117.54795 1122.1769,122.09761 1131.0726,126.10407 L 1132.702,91.404348 C 1122.4486,87.941206 1108.0523,84.953356 1093.4529,84.953356 C 1050.6044,84.953356 1034.6467,106.07195 1034.6467,130.65373 C 1034.6467,148.30912 1041.1654,161.95811 1063.6423,169.97097 L 1078.5134,175.26758 C 1090.4652,179.61356 1094.2679,182.26184 1094.2679,187.08316 C 1094.2679,193.46624 1087.477,196.92943 1074.1674,196.92943 C 1057.1237,196.92943 1044.9681,190.81796 1037.3628,187.08316 L 1036.2767,224.22741 C 1044.1536,227.14735 1063.914,230.61054 1079.3284,230.61054 C 1121.0903,230.61054 1139.7645,213.76996 1139.7645,184.91017",
    style: {
      fill: "#231f20",
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path18709"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1150.9009,227.41895 L 1199.6568,227.41895 L 1199.6568,26.962116 L 1150.9009,26.962116 L 1150.9009,227.41895 z ",
    style: {
      fill: "#231f20",
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path18711"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1505.1638,227.41895 L 1505.1638,129.83887 C 1505.1638,99.145608 1486.4895,84.953356 1462.3832,84.953356 C 1445.8822,84.953356 1433.3876,91.676006 1425.2389,105.80029 L 1424.424,105.80029 C 1424.9673,100.70742 1425.5106,94.324285 1425.5106,88.688155 L 1425.5106,26.962116 L 1376.7546,26.962116 L 1376.7546,227.41895 L 1425.5106,227.41895 L 1425.5106,150.95746 C 1425.5106,136.56146 1430.9426,123.999 1443.1656,123.999 C 1452.3329,123.999 1456.4073,130.38207 1456.4073,143.75946 L 1456.4073,227.41895 L 1505.1638,227.41895",
    style: {
      fill: "#231f20",
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path18713"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 759.42586,157.81588 C 759.42586,125.2892 779.52596,97.515828 807.97846,86.175651 L 833.78216,134.11687 L 803.76836,189.93518 L 842.54196,189.93518 L 872.55636,134.11687 L 844.03616,81.082727 C 883.08196,84.885441 913.57116,117.75169 913.57116,157.81588 C 913.57116,200.39258 879.07506,234.88855 836.49876,234.88855 C 793.92186,234.88855 759.42586,200.39258 759.42586,157.81588",
    style: {
      fill: "#32b53f",
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path18715"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1211.0648,157.06893 C 1211.0648,114.49224 1245.5609,79.996261 1288.1378,79.996261 C 1330.7147,79.996261 1365.2103,114.49224 1365.2103,157.06893 C 1365.2103,197.13312 1334.7211,229.99937 1295.6752,233.80208 L 1324.1954,180.76794 L 1294.1811,124.88172 L 1255.3395,124.88172 L 1285.4218,180.76794 L 1259.6176,228.70916 C 1231.1653,217.36899 1211.0648,189.59561 1211.0648,157.06893",
    style: {
      fill: "#231f20",
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path18717"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVosslohLogo);
export default __webpack_public_path__ + "static/media/vossloh-logo.13375880cafaa3833a10270a82ac67c2.svg";
export { ForwardRef as ReactComponent };